import axios from "axios";
const ServiceURL = process.env.VUE_APP_SERVICEURL;

export default {
  name: "menus",
  state: {
    menus: [],
    specialMenus: []
  },
  getters: {
    getMenus: state => {
      return state.menus;
    },
    getIsSpecialMenus: state => {
      return state.specialMenus;
    }
  },
  mutations: {
    MENUS: (state, payload) => {
      state.menus = payload[0];
      // console.log(payload.slice(1));
      state.specialMenus = payload.slice(1);
    }
  },
  actions: {
    FETCH_MENUS(store) {
      return axios({
        method: "get",
        url: ServiceURL + "menu",
        params: {
          tlc: store.rootState.auth.auth.username
        },
        auth: {
          username: store.rootState.auth.auth.username,
          password: store.rootState.auth.auth.password
        },
        headers: {
          "X-API-KEY": store.rootState.auth.auth.apikey
        }
      })
        .then(response => {
          store.commit("MENUS", response.data.data);
        })
        .catch(err => {
          return err;
        });
    }
  }
};
